export const data1 = {
    title: "智慧病案解决方案",
    children: [
        {
            title: "病案统计管理系统",
            content: [
                { type: "title", value: "产品介绍" },
                {
                    type: "text",
                    value:
                        "普康病案统计管理系统是医院信息系统建设中的重要组成部分，是集病案收集、整理、存储、查询、统计等功能于一体的医疗信息系统，涵盖了医院门诊日志、病人病案首页、医院统计报表等大量信息，不仅能反映出医院经营管理的现状和水平也能为医院的经营管理决策提供科学可靠的依据。",
                },
                { type: "img", value: "img_product1" },
                { type: "title", value: "核心功能" },
                { type: "img", value: "img_product2" },
                { type: "title", value: "产品优势" },
                {
                    type: "text2",
                    value: "无缝对接:与质控系统对接，提升编码效率与质量。",
                },
                {
                    type: "text2",
                    value: "模板配置:支持首页模板配置，可扩展附页。",
                },
                {
                    type: "text2",
                    value: "自动映射:多版本编码自动映射，支持IDC-11标准。",
                },
                {
                    type: "text2",
                    value: "检索控件:多种首页检索方式，满足个性化需求。",
                },
                {
                    type: "text2",
                    value: "医保功能:支持医保结算清单生成，提供质控与上报功能。",
                },
                {
                    type: "text2",
                    value: "报表生成:报表可拖拽生成，支持图表转化。",
                },
                { type: "text2", value: "对接方式:多种对接方式，接口灵活。" },
                {
                    type: "text2",
                    value:
                        "集成管理:集成式管理首页上报相关平台，配置化调整上报内容，",
                },
                {
                    type: "text2",
                    value: "评分表生成:支持评分表生成，数据校验流程完善，",
                },
                {
                    type: "text2",
                    value:
                        "全流程管理:满足全流程闭环管理，包括事前质控、分配、质控、打回、编目等环节。",
                },
                { type: "title", value: "应用意义" },
                {
                    type: "text",
                    value:
                        "1.提高编码效率与质量:与病案首页全流程质控系统无缝对接，支持多种编码自动映射功能和模板配置，可扩展附页，有效提高病案科编码的效率和准确性。",
                },
                {
                    type: "text",
                    value:
                        "2.满足医院个性化需求:支持多种首页检索方式和自定义检索控件，满足医院不同场景下的数据检索需求。",
                },
                {
                    type: "text",
                    value:
                        "3.支持医保结算清单生成与质控:系统支持首页数据生成医保结算清单，提供质控与上报功能，有助于医院快速、准确地完成医保结算工作。",
                },
                {
                    type: "text",
                    value:
                        "4.报表生成与可视化展示:支持报表的拖拽生成和图表相关转化，便于用户进行数据分析和可视化展示，为医院管理层提供决策支持。",
                },
                {
                    type: "text",
                    value:
                        "5.灵活的对接方式:支持多种对接方式，接口对接灵活，便于与其他医疗信息系统进行集成。",
                },
                {
                    type: "text",
                    value:
                        "6.集成式管理首页上报平台:集成式管理首页上报的相关平台，支持配置化调整上报内容，提高数据管理效率7.完善的事前质控流程:满足对病案首页的事前质控、分配、质控、打回、编目的全流程闭环管理，有助于提高病案数据的完整性和准确性。",
                },
                // { type: "img", value: "banner_product" },
            ],
        },
        {
            title: "病案示踪管理系统",
            content: [
                { type: "title", value: "产品介绍" },
                {
                    type: "text",
                    value:
                        "普康病案示踪管理系统详细记载病案从回收至入库的每一环节，提供了对病案的签出、签收、内部流转、上架、入库、借阅、复印、归还等环节的管理措施，从而管理纸质病案的实时流通状态，帮助医院实现了病案流向管理的规范化、系统化、数字化。",
                },
                { type: "img", value: "img_product3" },
                { type: "title", value: "核心功能" },
                { type: "img", value: "img_product4" },
            ],
        },
    ],
}
export const data2 = {
    title: "医疗质控解决方案",
    children: [
        {
            title: "病案首页全流程质控系统",
            content: [
                { type: "title", value: "产品介绍" },
                {
                    type: "text",
                    value:
                        "病案首页作为患者诊疗过程的精要，不仅是医疗信息的基础来源，更是医院医疗水平与质量的重要体现。加强病案质控，不仅能显著提升医疗服务的品质，还是预防医疗纠纷的关键措施。普康病案首页质控系统致力干从多个维度，包括完整性、合理性和规范性等，对病案首页的填写质量进行持续的优化和改进。通过这种方式，系统有效降低了病案的缺陷率，推动了病案管理的标准化、体系化和规范化，实现了全面的闭环管理。",
                },
                { type: "title", value: "核心功能" },
                { type: "img", value: "img_product5" },
                { type: "title", value: "产品优势" },
                {
                    type: "text",
                    value:
                        "1.AI内涵质控:利用先进技术搭建质控规则引擎，全面检测病案首页数据显著提升数据质量。",
                },
                {
                    type: "text",
                    value:
                        "2.事前质控:确保医生填写的完整性、规范性和逻辑性，实时监控。",
                },
                {
                    type: "text",
                    value: "3.人工质控:针对关键病例进行人工审核，提供反馈和评分。",
                },
                {
                    type: "text",
                    value:
                        "4.智能编码推荐:基于海量行业标准和医学知识，为医生提供精准推荐。",
                },
                {
                    type: "text",
                    value:
                        "5.医学专用语料库:根据中文医学特点，结合实际书写习惯构建医学专用语料库，支持高精度语言处理。",
                },
                {
                    type: "text",
                    value: "6.分析报告:多维度分析数据质量、重点指标问题等。",
                },
                { type: "title", value: "应用意义" },
                {
                    type: "text",
                    value:
                        "1.降低病案缺陷:通过内置的知识库和质控规则库，协助医院解决各种潜在的缺陷问题，显著提升病案质量。",
                },
                {
                    type: "text",
                    value:
                        "2.提升病案质量:实现病案首页的全面质控,通过实时提醒来帮助医生填补缺陷和漏洞，从而提升病案首页的填写质量。",
                },
                {
                    type: "text",
                    value:
                        "3.提高工作效率:通过实时的质控功能，减少人工操作的繁琐性，同时提高数据的客观性和可信度。",
                },
                {
                    type: "text",
                    value:
                        "4.提高DRG/DIP入组率:有效预防高编、低编、错编和漏编等常见问题，从而提高DRG/DIP的入组率。",
                },
            ],
        },
        {
            title: "AI电子病历质控系统",
            content: [
                { type: "title", value: "产品介绍" },
                {
                    type: "text",
                    value:
                        "普康AI电子病历质控系统是一款利用人工智能技术对电子病历进行质量控制的系统。基于知识图谱与强大的自然语言处理等技术，对电子病历的完整性、准确性、规范性等进行全面检测和评估，以提高病历质量，为医疗安全提供有力保障。",
                },
                { type: "img", value: "img_product6" },
                { type: "title", value: "核心功能" },
                {
                    type: "text",
                    value:
                        "通过知识图谱和自然语言处理、认知计算等AI技术，构建专业医学知识库和质控模型，对运行病历进行实时监控与提醒。在医生书写病历的过程中实时推送不符合规范的选项及扣分分值;同时支持对出院病历的归档病历进行自动质控评分。",
                },
                { type: "img", value: "img_product7" },
                { type: "title", value: "产品优势" },
                {
                    type: "text",
                    value:
                        "基于AI可对全量病历进行分析:完整性、时效性、有效性、一致性、合理性、规范性;基于国家规范或医院管理定义的内涵特殊约束。",
                },
                { type: "img", value: "img_product8" },
                { type: "title", value: "应用意义" },
                {
                    type: "text",
                    value:
                        "1.提升病历数据质量:实施全面数据监测、核查和上报机制，从源头上优化病案信息，推动病案管理数字化进程。",
                },
                {
                    type: "text",
                    value:
                        "2.降低医疗出错率:通过严谨的校验、预警和提示措施，有效降低医疗错误，有力保障患者的合法权益。",
                },
                {
                    type: "text",
                    value:
                        "3.减轻科室工作负担:采用机器+人工的质控方式，替代人工抽检，减轻科室工作负担，提升数据质量和效率。",
                },
                {
                    type: "text",
                    value:
                        "4.提升DRG/DIP分组准确性:预防高编、低编、错编和漏编等情况，提高病例准确分组率。",
                },
            ],
        },
        {
            title: "医保结算清单质控系统",
            content: [
                { type: "title", value: "产品介绍" },
                {
                    type: "text",
                    value:
                        "普康医保结算清单质控系统是一款高效的管理系统，专注于提高医保结算清单的质量和准确性。该系统凭借其内置丰富的质控规则库，连通了从数据采集、清单编制、质量监控、审核到上报的所有服务模块，全面覆盖了院内的医保结算清单管理流程。不仅为医院提供了全面的管理工具，还为医保清单提供了严密的监控机制。",
                },
                { type: "img", value: "img_product9" },
                { type: "title", value: "产品优势" },
                {
                    type: "text",
                    value:
                        "1.高可配: 系统提供高度灵活的配置能力，允许用户自定义数据质控规则和管理模式，以满足不同医院的差异化需求。",
                },
                {
                    type: "text",
                    value:
                        "2.一站式:系统涵盖医保结算清单的完整流程，包括数据采集、生成、ICD编码编目、质控、修改、展示、审核和上报等。",
                },
                {
                    type: "text",
                    value:
                        "3.全过程:系统支持清单数据的全流程管理，包括数据流转、质控、分组和违规监测，确保数据的准确性和完整性。",
                },
                {
                    type: "text",
                    value:
                        "4.多模式:系统支持多种管理模式，满足不同角色用户需求。同时，提供实时交互和数据修改痕迹留存。",
                },
                {
                    type: "text",
                    value:
                        "5.双保障:系统采用双重质控方式，包括自动质控和手动质控、形式质控和内涵质控，确保数据缺陷得到全面检测和纠。",
                },
                {
                    type: "text",
                    value:
                        "6.高权威:系统内置国家医保局对清单填报的要求，确保数据的合规性和权威性，为医院提供高质量的数据管理工具。",
                },
            ],
        },
    ],
}
export const data3 = {
    title: "DRG/DIP解决方案",
    children: [
        {
            title: "DRG运营监测管理系统",
            content: [
                { type: "title", value: "产品介绍" },
                {
                    type: "text",
                    value:
                        "普康DRG运营监管系统是一款实时监控系统，致力于医保在院运行管理。通过全程监控患者入院至出院的费用和入组情况，该系统可确保医保资金有效使用和患者的合理权益。与HIS或电子病历系统集成，为医院提供全面的数据支持和决策依据。",
                },
                { type: "img", value: "img_product10" },
                { type: "title", value: "产品优势" },
                {
                    type: "text",
                    value:
                        "系统具备强大的预警功能，不仅内置了多条预警规则，而且用户还可以根据需求自定义预警规则，并根据风险程度设置不同等级。该系统能够实时监测院内发生的费用风险及不合理行为，并通过智能提醒，协助医师及时、有效地处理风险因素，从而降低费用超支的风险。",
                },
            ],
        },
        {
            title: "DIP病种分支精细化管理系统", content: [
                { type: "title", value: "产品介绍" },
                {
                    type: "text",
                    value: '普康DIP运营监管系统致力于精准把控医疗成本，优化病种结构。通过全面的在院运行监管、医保费用盈亏分析及异常费用预警，助力医院提升医疗能力，实现预期医保支付效果。'
                },
                { type: "img", value: "img_product11" },
                { type: "title", value: "产品优势" },
                { type: 'text', value: '1.全面监管:涵盖在院运行监管、医保费用盈亏分析及异常费用预警分析等功能，确保医保支付的合规性和准确性。' },
                { type: 'text', value: '2.精准分析:对全院、科室和人员进行三级指标及医保费用情况的分析，帮助医院优化病种结构，制定精准控费策略。' },
                { type: 'text', value: '3.成本控制:通过系统智能分析和预警，有效控制医疗成本，提高医院运营效率。' },
                { type: 'text', value: '4.提升医疗能力:系统助力医院提升医疗能力建设，提高医疗服务质量，满足患者需求。' },
                { type: 'text', value: '5.预期医保支付效果:通过系统的全面监管和分析，确保医院获得预期的医保支付效果，保障医院和患者的利益。' },
            ]
        },
    ],
}
export const data4 = {
    title: "医疗管理解决方案",
    children: [
        {
            title: "单病种质量管理系统", content: [
                { type: "title", value: "产品介绍" },
                { type: 'text', value: '普康单病种质量管理系统致力于对单病种进行集中管理、质量控制和数据上报。通过自动化的数据采集和统计分析，该系统能够确保医院单病种质量控制指标的准确性和可靠性，从而为医院提供有力的数据支撑，助力医院提升单病种质量管理水平。' },
                { type: "img", value: "img_product12" },
                { type: "title", value: "产品优势" },
                { type: 'text', value: '1.自动化病种筛选:自动筛选病例，确保应上报的全部检出，不应上报的全部剔除，节省时间和人力，提高筛选准确性。' },
                { type: 'text', value: '2.便捷的人工录入:系统提供针对不同数据项特点的便捷填报方式，方便用户快速录入数据，同时自动进行数据格式和数据范围的校验和提示，提高数据准确性。' },
                { type: 'text', value: '3.过程管理与终未分析并重:系统不仅关注病种诊疗服务的过程管理，还重视终未分析，帮助医院实现事前、事中、事后全流程质控，全面提升病种诊疗服务质量。' },
                { type: 'text', value: '4.灵活配置的数据分析:根据不同病种和不同分析目的，用户可以灵活配置用于不同分析诉求的统计方式，以满足多样化的数据分析需求。' },
            ]
        },
        {
            title: "核心指标分析系统", content: [
                { type: "title", value: "产品介绍" },
                { type: 'text', value: '普康核心指标分析系统是一款涵盖指标定义、指标建模、指标固化、指标可视化分析，实现指标全流程、一体化管理的软件产品，可灵活配置可视化指标反馈图表，支持报表、看板、刊报等多个生成展示方式，采用全拖拽式的配置方法，步骤简单、界面清晰，医院人员轻松驾驭。' },
                { type: "img", value: "img_product13" },
                { type: "title", value: "产品优势" },
                { type: 'text', value: '1.指标定义与建模:用户可以根据业务需求，定义各种关键指标，并进行相应的建模。这些指标可以涉及财务、运营、患者满意度等多个方面。' },
                { type: 'text', value: '2.指标固化:在完成指标定义和建模后，用户可以将这些指标进行固化，确保数据的准确性和可靠性。' },
                { type: 'text', value: '3.可视化分析:系统支持灵活配置各种可视化反馈图表，如柱状图、折线图、饼图等，帮助用户直观地了解和分析数据。' },
                { type: 'text', value: '4.多种生成展示方式:除了传统的报表，该系统还支持看板、刊报等多种展示方式满足不同用户的需求。' },
                { type: 'text', value: '5.全拖拽式配置:系统采用全拖拽式的配置方法，用户可以通过简单的拖放操作完成各种配置，步骤简单、界面清晰。' },
                { type: 'text', value: '6.一体化管理:普康核心指标分析系统实现了从指标定义到可视化分析的一体化管理，为用户提供全面的解决方案。' },
                // { type: "img", value: "img_product14" },
                { type: "title", value: "应用意义" },
                { type: 'text', value: '1.提升医疗质量:监测核心指标，发现并改进服务不足，提高医疗质量和患者满意度。' },
                { type: 'text', value: '2.辅助决策支持:提供实时、准确数据，帮助管理层做出科学决策，提升管理水平。' },
                { type: 'text', value: '3.优化资源配置:评估资源核心指标，合理分配资源，提高资源利用效率，减少浪费。' },
                { type: 'text', value: '4.促进跨科室协作:整合不同科室数据，加强信息交流和协作，提升整体服务水平。' },
                { type: 'text', value: '5.提高科研水平:深入研究和分析核心指标，支持医学研究和教学，促进医学科技进步。' },
                { type: 'text', value: '6.提升医院形象:展示医疗质量、管理水平和科研能力优势，提升医院社会形象和声誉。' },
                { type: 'text', value: '7.降低医疗成本:降低不必要的医疗开支，减轻患者经济负担，提高整体经济效益。' },
                { type: 'text', value: '8.推动数字化转型:核心指标分析系统助力医院向智能化、高效化方向发展。' },
            ]
        },
        {
            title: "公立医院绩效考核管理系统", content: [
                { type: "title", value: "产品介绍" },
                { type: 'text', value: '普康公立医院绩效管理系统，依据国家卫生健康委公立医院绩效考核上报数据要求，致力于实现上报数据的自动采集与上报，从而显著减少手工工作量，提升工作效率。该系统不仅仅局限于数据采集和上报，更针对绩效考核的各项指标标准进行深入的多维分析。通过先进的数据分析技术，该系统能够帮助医院提升运营和质量管理能力，为其可持续发展提供有力支持。' },
                { type: "img", value: "img_product14" },
                { type: "title", value: "产品优势" },
                { type: 'text', value: '1.先进技术应用:利用先进的大数据技术，高效利用院内数据资源，提升医疗质量管理。' },
                { type: 'text', value: '2.精细化管理:帮助医院从粗放式行政管理转向精细化绩效管理，提升管理效率。' },
                { type: 'text', value: '3.绩效考核系统建设:满足国家卫健委的绩效考核要求，支持三级公立医院绩效考核信息系统建设。' },
                { type: 'text', value: '4.大数据优势:充分发挥大数据的潜力，提高数据准确性，进而提升医院管理水平。' },
                { type: 'text', value: '5.便捷的人工录入:提供便捷的数据填报方式，并自动校验数据格式和范围，提高数据准确性。' },
                { type: 'text', value: '6.灵活的数据分析:用户可灵活配置统计方式，满足多样化的数据分析需求。' },
                { type: 'text', value: '7.过程与终末分析并重:既关注诊疗过程，也重视终末分析，实现全流程质控。' },
                { type: 'text', value: '8.自动病例筛选:自动筛选病例，提高上报准确性，节省时间和人力。' },
                { type: 'text', value: '9.实时性与动态性:支持实时数据采集、计算和报告生成，并能动态调整指标和内容。' },
                { type: 'text', value: '10.可视化与交互:提供丰富的可视化工具和交互功能，帮助用户直观了解数据并定制报告。' },
            ]
        },
        {
            title: "医院等级评审系统", content: [
                { type: "title", value: "产品介绍" },
                { type: 'text', value: '普康医院等级评审系统专注于从医院的功能与任务、规模与运营管理，以及医疗质量与技术水平三大维度出发，为医院等级评审提供全面的支持。该系统能够实现快速的数据采集、整理、分析、存储及管理，确保数据的准确性和完整性。通过灵活的配置，系统能够生成各种可视化指标反馈图表，帮助评审专家直观地了解医院运营状况。' },
                { type: "img", value: "img_product15" },
                { type: "title", value: "产品优势" },
                { type: 'text', value: '1.个性化展示:突出显示关键指标，支持图表数据的自定义展示和导出，满足个性化需求。' },
                { type: 'text', value: '2.数据完整性:全面采集数据，统一标准，确保数据清洗和整理的准确性，提高计算正确性。' },
                { type: 'text', value: '3.深度数据挖掘:深入挖掘数据，提供科室、时间、人员等多维度分析，帮助用户了解细节。' },
                { type: 'text', value: '4.动态监管:实时监控各项指标，按月、季、年分析变化趋势，便于及时调整和改进。' },
                { type: 'text', value: '5.任务配置灵活:支持科室管理和等级评审独立操作，配置不同角色权限，简化评审工作流程。' },
                { type: 'text', value: '6.指标全面分析:提供详细的指标目录清单，设置目标值及区间目标管理，自动展示指标发展趋势。' },
            ]
        },
    ],
}
export const data5 = {
    title: "智慧病案解决方案",
    children: [{
        title: "配置化数据上报集成系统", content: [
            { type: "title", value: "产品介绍" },
            { type: 'text', value: '普康配置化数据上报集成系统是一种高效、灵活、可扩展的数据集成上报解决方案，将上报平台集成到一起统一管理，采用配置化的方式快速地将不同来源的数据进行整合、清洗、转换和上报。' },
            { type: "img", value: "img_product16" },
            { type: "title", value: "产品优势" },
            { type: 'text', value: '系统将多元上报平台统一纳入管理(卫生统计网络直报病案首页上报、公立医院绩效考核病案首页上报、NCIS医疗服务与质量安全病案首页上报、医院质量监测病案首页上报(HQMS)、职称评审病案首页上报…)，凭借配置化手段，迅速整合、清洗、转换及上报各类数据，简化了数据上报流程，提高了工作效率，为医院的数据管理之旅保驾护航。' },
            { type: "img", value: "img_product17" },
        ]
    }],
}